module.exports = __webpack_public_path__ + "da1cd88b8513a0492c6129be8d98e9e1.png";